// ** React Imports
import {createContext, ReactNode} from "react";

// ** Types
import {authService} from "../services/authentication-service";



const AuthContext = createContext(authService);

const AuthProvider = ({ children }) => {
  return <AuthContext.Provider value={authService}>{children}</AuthContext.Provider>;
};

export { AuthContext, AuthProvider };
